import { render, staticRenderFns } from "./AppUserAvatar.vue?vue&type=template&id=4146313e&scoped=true&lang=pug"
import script from "./AppUserAvatar.vue?vue&type=script&lang=ts"
export * from "./AppUserAvatar.vue?vue&type=script&lang=ts"
import style0 from "./AppUserAvatar.vue?vue&type=style&index=0&id=4146313e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4146313e",
  null
  
)

export default component.exports